// ES
export const reservasHc = {
  // ── CheckinsList.vue ──────────────────────────────────────────────────────
  checkinsList: {
    // Toolbar / dispatch cards
    newCheckin: "Nuevo check-in",
    manualDispatchTitle: "Cierre manual del envío final",
    manualDispatchText:
      "Si uno de los huéspedes no viajará, puedes cerrar manualmente este proceso para enviar ahora el mensaje de bienvenida, las llaves digitales y el documento al responsable de la reserva.",
    sending: "Enviando...",
    completeManualSend: "Completar manual y enviar",
    finalSendProcessed: "Envío final ya procesado",
    arrivalInstructions: "Instrucciones de llegada",
    arrivalAlreadySent: "Ya enviadas. Puedes reenviarlas ahora al huésped si lo necesitas.",
    arrivalAutoInfo:
      "Se envían automáticamente a su hora. Puedes adelantarlas y mandarlas ahora (mensaje, accesos y archivos configurados).",
    resendNow: "Reenviar ahora",
    sendNow: "Enviar ahora",

    // Row titles
    titleEditCheckin: "Editar check-in",
    titleDeleteCheckin: "Eliminar check-in",

    // Manual dispatch confirm/alert
    confirmManualTitle: "¿Completar envío manualmente?",
    confirmManualMsg:
      "Usa esta acción cuando ya no habrá más huéspedes haciendo check-in y necesitas enviar ahora la información final al responsable de la reserva.",
    yesSendNow: "Sí, enviar ahora",
    cancel: "Cancelar",
    manualSendFailed: "No se pudo completar el envío manual.",
    sendProcessedTitle: "Envío procesado",
    finalInfoProcessed: "La información final del check-in ya fue procesada.",
    couldNotSend: "No se pudo enviar",

    // Arrival send confirm/alert
    confirmResendArrivalTitle: "¿Reenviar instrucciones de llegada?",
    confirmSendArrivalTitle: "¿Enviar instrucciones de llegada ahora?",
    confirmResendArrivalMsg:
      "Las instrucciones de llegada ya se enviaron. ¿Quieres volver a enviarlas ahora al huésped?",
    confirmSendArrivalMsg:
      "Se enviarán ahora al huésped las instrucciones de llegada (mensaje, accesos y archivos configurados), sin esperar a la hora programada.",
    arrivalSendFailed: "No se pudieron enviar las instrucciones de llegada.",
    pendingDeliveryTitle: "Pendiente de entrega",
    instructionsSentTitle: "Instrucciones enviadas",
    arrivalSentToGuest: "Las instrucciones de llegada se enviaron al huésped.",

    // Modal header steps
    stepGuestData: "Datos del huésped",
    stepSignature: "Firma",
    stepRegistered: "Check-in registrado",

    // Sections
    sectionPersonal: "Datos personales",
    sectionStay: "Estancia",
    sectionDocument: "Documento",

    // Personal fields
    nombre: "Nombre",
    apellido: "Apellido",
    sexo: "Sexo",
    select: "Selecciona",
    male: "Masculino",
    female: "Femenino",
    preferNotToSay: "Prefiero no decirlo",
    other: "Otro",
    birthDate: "Fecha de nacimiento",
    minorsTraveling: "¿Viajan menores en esta reserva?",
    no: "No",
    yes: "Sí",
    relationshipMinor: "Parentesco del menor",
    relationshipToMinor: "Parentesco respecto al menor",
    phone: "Teléfono",
    email: "Email",
    checkInDate: "Fecha ingreso",
    checkOutDate: "Fecha salida",

    // Document
    nationality: "Nacionalidad",
    cittadinanza: "Cittadinanza / Nacionalidad",
    documentType: "Tipo documento",
    documentNumber: "Número de documento",
    supportNumber: "Número de soporte",
    docTypes: {
      passport: "Pasaporte",
      identityDoc: "Documento de Identidad",
      co_cc: "Cédula de Ciudadanía",
      co_ce: "Cédula de Extranjería",
      co_ppt: "Permiso Protección Temporal",
      co_pep: "Permiso Especial de Permanencia",
      co_de: "Documento Extranjero",
    },
    relationships: {
      co: {
        PADRE: "Padre",
        MADRE: "Madre",
        HIJO: "Hijo/a",
        ABUELO: "Abuelo/a",
        HERMANO: "Hermano/a",
        TIO: "Tío/a",
        TUTOR: "Tutor/a legal",
        OTRO: "Otro",
      },
      es: {
        HJ: "Hijo/a",
        AB: "Abuelo/a",
        BA: "Bisabuelo/a",
        BN: "Bisnieto/a",
        CD: "Cuñado/a",
        CY: "Cónyuge",
        HR: "Hermano/a",
        NI: "Nieto/a",
        OT: "Otro",
        PM: "Padre/Madre",
        SB: "Sobrino/a",
        SG: "Suegro/a",
        TI: "Tío/a",
        TU: "Tutor/a",
        YN: "Yerno/Nuera",
      },
    },

    // Italy — Alloggiati Web
    italyBannerTitle: "Dati richiesti in Italia · Alloggiati Web",
    italyBannerText:
      "La Polizia di Stato richiede lo stato di nascita, il comune di nascita e il luogo di rilascio del documento.",
    sectionBirthData: "Dati di nascita",
    statoNascita: "Stato di nascita / País de nacimiento",
    birthStateHint: "El estado de nacimiento puede ser distinto de la nacionalidad.",
    comuneNascita: "Comune di nascita",
    luogoRilascio: "Luogo di rilascio del documento",
    luogoRilascioHint: "Comune italiano o Estado extranjero que expidió el documento.",
    searchCittadinanza: "Cerca la cittadinanza…",
    searchStatoNascita: "Cerca lo stato di nascita…",
    searchComuneNascita: "Cerca il comune di nascita…",
    searchComuneRilascio: "Comune di rilascio…",
    searchStatoRilascio: "Stato di rilascio…",

    // Spain — SES Hospedajes
    sectionSes: "Datos SES Hospedajes",
    countryResidence: "País de residencia",
    cityResidence: "Ciudad de residencia",
    address: "Dirección",
    zipCode: "Código postal",
    paymentMethod: "Forma de pago",
    paymentDate: "Fecha de pago",
    pay: {
      efectivo: "Efectivo",
      destino: "Pago en destino",
      tarjeta: "Tarjeta",
      movil: "Pago móvil",
      plataforma: "Plataforma",
      transferencia: "Transferencia",
    },

    // Colombia — SIRE / TRA
    sireLegalTitle: "SIRE & TRA — Aviso Legal",
    sireLegalText:
      "Para establecimientos en Colombia, la información solicitada se recolecta conforme a la normativa de Migración Colombia (SIRE) y al registro de huéspedes (TRA).",
    sectionSire: "Datos SIRE / TRA",
    searchNationality: "Buscar nacionalidad...",
    searchCountry: "Buscar país...",
    noResults: "Sin resultados",
    countryOrigin: "País de procedencia",
    searchCountryOrigin: "Buscar país de procedencia...",
    cityOrigin: "Ciudad de procedencia",
    searchCity: "Buscar ciudad...",
    searchMunicipality: "Buscar municipio...",
    nextDestinationCountry: "País próximo destino",
    searchDestinationCountry: "Buscar país de destino...",
    summaryOrigin: "Procedencia",
    summaryDestination: "Destino",

    // Identity verification
    sectionIdentity: "Verificación de identidad",
    recommended: "recomendado",
    identityActiveInfo:
      "La propiedad tiene verificación de identidad activa. Sube fotos del documento del huésped.",
    documentFront: "Frente del documento",
    uploadPhoto: "Subir foto",
    selfieGuest: "Selfie del huésped",
    altDocumentFront: "Documento frente",
    altMinorAuth: "Autorización menor",
    titleRemove: "Eliminar",

    // Minor docs
    sectionMinorDocs: "Documentación del menor",
    optional: "opcional",
    minorInfo: "Para menores de edad puedes subir la autorización de viaje o el documento del tutor.",
    guardianAuthDoc: "Autorización / Documento del tutor",
    uploadDocument: "Subir documento",

    // Signature step
    sectionSignature: "Firma del huésped",
    signatureHint: "Pide al huésped que firme en el recuadro para aceptar los términos del alojamiento.",
    undo: "Deshacer",
    clear: "Limpiar",
    termsAccept: "El huésped acepta los términos y condiciones del alojamiento",

    // Success step
    successTitle: "¡Check-in registrado!",
    successBefore: "El check-in de",
    successAfter: "ha sido guardado correctamente.",

    // Footer buttons
    next: "Siguiente",
    back: "Atrás",
    saving: "Guardando...",
    saveCheckin: "Guardar check-in",
    close: "Cerrar",

    // Validation toasts
    vNombre: "El nombre es requerido",
    vApellido: "El apellido es requerido",
    vSexo: "El sexo es requerido",
    vBirthDate: "La fecha de nacimiento es requerida",
    vPhone: "El teléfono es requerido",
    vCheckIn: "La fecha de ingreso es requerida",
    vCheckOut: "La fecha de salida es requerida",
    vNationality: "La nacionalidad es requerida",
    vDocType: "El tipo de documento es requerido",
    vDocNumber: "El número de documento es requerido",
    vEmailFormat: "El email no tiene un formato válido",
    vDocSupport: "El número de soporte del documento es requerido",
    vMinors: "Indica si viajan menores en la reserva",
    vRelationship: "El parentesco del acompañante menor es requerido",
    vCountryResidence: "El país de residencia es requerido",
    vCityResidence: "La ciudad de residencia es requerida",
    vAddress: "La dirección es requerida",
    vZip: "El código postal es requerido",
    vPaymentMethod: "La forma de pago es requerida",
    vPaymentDate: "La fecha de pago es requerida",
    vCountryOrigin: "El país de procedencia es requerido",
    vNextDest: "El país de próximo destino es requerido",
    vCityOrigin: "La ciudad de procedencia es requerida",
    vStatoNascita: "El estado de nacimiento (Stato di nascita) es requerido",
    vComuneNascita: "El municipio de nacimiento (Comune di nascita) es requerido",
    vLuogoRilascio: "El lugar de expedición del documento (Luogo di rilascio) es requerido",

    // Save toasts
    vTerms: "Debes aceptar los términos para continuar",
    vSignaturePad: "Error al acceder al panel de firma",
    vSignature: "La firma es requerida",
    saveCheckinError: "Ocurrió un error al guardar el check-in",
    saveCheckinErrorGeneric: "Error al guardar el check-in",
    socketCheckinDone: "<strong>{name}</strong> completó el check-in manual",
    identityPhotosError: "El check-in fue guardado, pero no se pudieron subir las fotos de identidad",
    minorAuthError: "El check-in fue guardado, pero no se pudo subir la autorización del menor",

    // Document validation messages
    docDni: "DNI inválido. Debe tener 8 dígitos seguidos de la letra de control correcta (ej: 12345678Z)",
    docNie: "NIE inválido. Formato: X/Y/Z + 7 dígitos + letra de control (ej: X1234567Z)",
    docPassport: "Pasaporte inválido. Debe tener entre 6 y 20 caracteres alfanuméricos",
    docCc: "Cédula de Ciudadanía inválida. Debe tener entre 6 y 10 dígitos",
    docCe: "Cédula de Extranjería inválida. Debe tener entre 6 y 12 caracteres alfanuméricos",
    docPptPep: "{tipo} inválido. Debe tener entre 4 y 15 caracteres alfanuméricos",

    // Postal
    zipNotFound: "Código postal no encontrado. Verifica el número e inténtalo de nuevo.",
  },

  // ── PageReservation.vue ───────────────────────────────────────────────────
  pageReservation: {
    // Status banners
    requestPendingTitle: "Solicitud de reserva pendiente",
    requestPendingText:
      "El huésped solicitó estas fechas. El calendario no está bloqueado hasta que apruebes.",
    approving: "Aprobando…",
    approve: "Aprobar",
    rejecting: "Rechazando…",
    reject: "Rechazar",
    requestRejectedTitle: "Solicitud rechazada",
    requestRejectedText: "Esta solicitud fue rechazada por el alojamiento y ya no puede confirmarse.",
    awaitingPaymentTitle: "Esperando pago del huésped",
    awaitingPaymentText:
      "El calendario está bloqueado temporalmente. Si no paga, la disponibilidad se libera automáticamente.",
    remaining: "restante",
    marking: "Marcando...",
    markAsPaid: "Marcar como pagada",
    expiring: "Expirando...",
    markAsExpired: "Marcar como expirada",

    // Extension banner
    extensionPendingTitle: "Ampliación de estancia pendiente",
    extraNights: "{count} noche(s) extra",
    newCheckout: "nueva salida",
    awaitingGuestPayment: "esperando el pago del huésped",
    holdLeftMinutes: "quedan {min} min para pagar",
    holdLeftSeconds: "quedan {seg} s para pagar",
    holdExpired: "el plazo venció: las noches se liberaron",
    pendingApproval: "pendiente de aprobación",
    confirming: "Confirmando...",

    // Observation
    observation: "Observación",

    // Service charges
    pendingCharge: "pendiente de cobro",
    processing: "Procesando...",

    // Service requests
    clientRequested: "El cliente solicitó:",
    serviceFallback: "Servicio",
    toConsult: "a consultar",

    // Approve modal
    approveRequestTitle: "Aprobar solicitud",
    amountToCharge: "Importe a cobrar",
    noCharge: "0 = sin cargo",
    approveHint:
      "Si tienes pasarela conectada, se le envía al huésped un <strong>link de pago</strong> (WhatsApp + correo). Si no, se le indica que <strong>pagará a su llegada</strong>.",
    cancel: "Cancelar",
    close: "Cerrar",
    approveAndNotify: "Aprobar y avisar",

    // Mark-paid modal
    reservationTotal: "Total de la reserva:",
    onRequestPaidSeparately: `los "a consultar" se pagan aparte`,
    fullPayment: "Pago total",
    noBalance: "(sin saldo)",
    deposit: "Adelanto",
    balance: "saldo",
    markPaidHint: `Se registra como cobrado el importe elegido. El "total" cubre estancia, limpieza y servicios con precio (p. ej. Uber); los "a consultar" tienen su propio cobro.`,
    confirm: "Confirmar",

    // Expired banner
    paymentExpiredTitle: "Tiempo de pago expirado",
    paymentExpiredText: "La reserva temporal expiró y la disponibilidad fue liberada automáticamente.",

    // Overbooking banner
    overbookingTitle: "Reserva en overbooking",
    overbookingText:
      "Sus fechas chocan con otra reserva de este alojamiento. Las fechas siguen bloqueadas en las OTAs. Si ya resolviste el conflicto (cancelaste o moviste la otra reserva), confírmala aquí.",
    verifying: "Verificando...",
    confirmReservation: "Confirmar reserva",

    // Actions bar
    checkinInvitation: "Invitación a check-in",
    copyCheckinLink: "Copiar link de check-in",
    editReservation: "Editar reserva",

    // Codes & access card
    codesAndAccess: "Códigos y accesos",
    codesAndAccessSub: "Claves y enlaces de acceso del huésped",
    currentAccessCodes: "Códigos de acceso actuales:",
    currentAccessCode: "Código de acceso actual:",
    guestDigitalAccess: "Acceso digital del huésped",
    copyOpenLink: "Copiar enlace de apertura",
    copy: "Copiar",
    openLink: "Abrir enlace de apertura",
    open: "Abrir",
    yacanNote: "El acceso de esta reserva lo gestiona <b>YACAN</b> automáticamente con sus cerraduras.",
    digitalKeyEkey: "Llave digital (ekey)",
    openDigitalKey: "Abrir llave digital",
    previousCodesExpired: "Códigos anteriores (ya caducados):",
    sentOn: "enviado el",
    generated: "generado",
    expiredOn: "caducó el",

    // Amount & payment card
    amountAndPayment: "Importe y pago",
    amountAndPaymentSub: "Desglose, estado del cobro y facturación",

    // Timeline
    guestJourney: "Recorrido del huésped",
    eventsCount: "{count} evento | {count} eventos",
    journeySubtitle: "Trazabilidad completa desde la reserva hasta la salida",
    stagesCompleted: "etapas completadas",
    nextLabel: "Próximo:",
    // Cabecera del bloque de etapas que aún no han ocurrido; van FUERA de la cronología.
    pendingAhead: "Lo que falta",
    // El envío del parte a las autoridades: cada servicio lo apunta en historial_firmas.
    authoritiesTitle: "Parte de viajeros",
    authoritiesAction: "fue declarado a las autoridades",
    authoritiesDesc: "Enviado a {services}",
    viewInChat: "Ver en el chat",

    // Static-code modal
    accessCode: "Código de acceso",
    accessCodeSub: "Edita y envía la clave al huésped",
    currentlyConfiguredCode: "Código configurado actualmente",
    newCode: "Nuevo código",
    keepSameToResend: "déjalo igual para reenviar sin cambios",
    placeholderCode: "Ej: ABCD1234",
    codeSavedUppercaseHint: "El código se guardará en mayúsculas y se enviará por WhatsApp y/o correo.",
    sending: "Enviando...",
    saveAndSendToGuest: "Guardar y enviar al huésped",

    // Computed button texts
    resendAccess: "Reenviar acceso",
    sendAccess: "Enviar acceso",
    resendPin: "Reenviar PIN",
    sendPin: "Enviar PIN",
    activating: "Activando...",
    resendCode: "Reenviar código",
    sendAccessCode: "Enviar código de acceso",

    // Timeline events (derived)
    channelManager: "channel manager",
    directBooking: "reserva directa",
    directTag: "Directa",
    bookingRegistered: "Reserva registrada",
    bookedViaOta: "reservó vía OTA",
    createdBooking: "creó la reserva",
    incomingVia: "Entrante vía {channel}",
    confirmedTag: "Confirmada",
    pendingTag: "Pendiente",
    bookingConfirmed: "Reserva confirmada",
    pendingConfirmation: "Pendiente de confirmar",
    receivedConfirmation: "recibió la confirmación de su reserva",
    awaitingConfirmationAction: "está pendiente de confirmación",
    propertyConfirmed: "El alojamiento confirmó la reserva",
    awaitingConfirmationDesc: "A la espera de confirmación",
    sentTag: "Enviada",
    notSentTag: "Sin enviar",
    checkinInvitationTitle: "Invitación de check-in",
    receivedCheckinInvite: "recibió la invitación de check-in",
    notReceivedCheckinInvite: "aún no recibió la invitación de check-in",
    checkinLinkSent: "Link de check-in enviado al huésped",
    inviteNotSentYet: "Aún no se ha enviado la invitación",
    completedTag: "Completado",
    checkinOnline: "Check-in online",
    didCheckinOnline: "realizó el check-in online",
    notYetCheckinOnline: "aún no realizó el check-in online",
    guestsRegistered: "{count} huésped(es) registrado(s)",
    guestNotCompletedCheckin: "El huésped aún no completó el check-in",
    sentTagPlural: "Enviados",
    accessCodes: "Códigos de acceso",
    receivedAccessCodes: "recibió los códigos de acceso",
    notReceivedAccessCodes: "aún no recibió los códigos de acceso",
    accessKeysSent: "Claves de acceso enviadas al huésped",
    pendingSendAccess: "Pendiente de enviar los accesos",
    finishedTag: "Finalizada",
    plannedTag: "Previsto",
    guestCheckout: "Salida del huésped",
    finishedStay: "finalizó su estancia",
    plannedCheckout: "tiene la salida prevista",
    stayFinished: "La estancia ha finalizado",
    autoCheckoutScheduled: "Check-out automático programado",
    theGuest: "El huésped",
    theTeam: "El equipo",
    theChannel: "El canal",
    theSystem: "El sistema",
    calledFromNumber: "llamó desde el número {phone}",

    // Timeline filters
    filterAll: "Todo",
    filterWhatsapp: "WhatsApp",
    filterCalls: "Llamadas",
    filterCheckin: "Check-in",
    filterAccess: "Acceso",
    filterBooking: "Booking",

    // Toasts / dialogs
    error: "Error",
    requestApprovedMsg: "Solicitud aprobada. La reserva está confirmada.",
    requestApprovedTitle: "✓ Aprobada",
    couldNotApprove: "No se pudo aprobar.",
    confirmRejectRequestMsg:
      "¿Estás seguro de que quieres rechazar esta solicitud? No se puede deshacer.",
    rejectRequestHeader: "Rechazar solicitud",
    yesReject: "Sí, rechazar",
    requestRejectedMsg: "Solicitud rechazada.",
    rejectedTitle: "Rechazada",
    couldNotReject: "No se pudo rechazar.",
    couldNotLoadOptions: "No se pudieron cargar las opciones; se marcará el total.",
    noticeTitle: "Aviso",
    depositMarkedPaid: "Adelanto marcado como pagado. Reserva confirmada con saldo pendiente.",
    fullMarkedPaid: "Reserva marcada como pagada al total y confirmada.",
    paymentConfirmedTitle: "Pago confirmado",
    couldNotMarkPaid: "No se pudo marcar como pagada.",
    tempReservationExpired: "La reserva temporal fue expirada y liberó disponibilidad.",
    reservationExpiredTitle: "Reserva expirada",
    couldNotMarkExpired: "No se pudo marcar como expirada.",
    extensionMarkedPaid: "La ampliación se marcó como pagada y quedó confirmada.",
    extensionConfirmedTitle: "Ampliación confirmada",
    couldNotConfirmExtension: "No se pudo confirmar la ampliación.",
    extensionCancelled: "La ampliación fue cancelada y se liberó la disponibilidad.",
    extensionRejectedTitle: "Ampliación rechazada",
    couldNotRejectExtension: "No se pudo rechazar la ampliación.",
    chargeMarkedPaid: "El cargo se marcó como pagado.",
    chargeRegisteredTitle: "Cobro registrado",
    couldNotMarkChargePaid: "No se pudo marcar el cargo como pagado.",
    chargeRejected: "El cargo fue rechazado y eliminado de la reserva.",
    chargeRejectedTitle: "Cargo rechazado",
    couldNotRejectCharge: "No se pudo rechazar el cargo.",
    approvedState: "Aprobado",
    rejectedState: "Rechazado",
    paidState: "Pagado",
    pendingYourResponse: "Pendiente de tu respuesta",
    enterValidAmount: "Indica un importe válido (0 = sin cargo).",
    amountTitle: "Importe",
    approvedPaymentLinkSent: "Aprobada. Se envió al huésped el link de pago (WhatsApp + correo).",
    serviceApprovedTitle: "Servicio aprobado",
    approvedPayOnArrival: "Aprobada. El huésped pagará a su llegada (sin pasarela conectada).",
    approvedGuestNotified: "Aprobada. Se avisó al huésped.",
    couldNotApproveRequest: "No se pudo aprobar la solicitud.",
    requestRejectedNotified: "Solicitud rechazada. Se avisó al huésped.",
    serviceRejectedTitle: "Servicio rechazado",
    couldNotRejectRequest: "No se pudo rechazar la solicitud.",
    resendAccessLinkMsg: "¿Desea reenviar el enlace de acceso por los canales disponibles?",
    sendAccessLinkMsg: "¿Desea enviar el enlace de acceso por los canales disponibles?",
    resendPinMsg:
      "¿Desea reenviar el código de acceso por los canales disponibles? Se generará un nuevo PIN.",
    sendPinMsg: "¿Desea generar y enviar el código de acceso por los canales disponibles?",
    sendDigitalAccessHeader: "Enviar Acceso Digital",
    sendPinHeader: "Enviar PIN de Acceso",
    send: "Enviar",
    accessLinkSent: "Enlace de acceso enviado al huésped",
    accessSentTitle: "Acceso Enviado",
    successSummary: "Éxito",
    digitalAccessSentDetail: "Se envió el acceso digital para {count} dispositivo(s)",
    ttlockCodesGenerated: "Se generaron y procesaron {count} códigos TTLock para la reserva.",
    accessCodeResent: "Código de acceso reenviado: {code}",
    accessCodeGeneratedSent: "Código de acceso generado y enviado: {code}",
    pinSentTitle: "PIN Enviado",
    pinProcessedDetail: "Se procesó el PIN para {count} cerradura(s)",
    pinProcessedBlebox: "y {count} puerta(s) electrónica(s)",
    couldNotSendAccessCode: "No se pudo enviar el código de acceso",
    codeCopied: "Código copiado al portapapeles",
    mainGate: "Portón principal",
    accommodation: "Alojamiento",
    doorLabel: "Puerta del alojamiento",
    validUntil: "Válido hasta: {date}",
    earlyAccessLinkMsg:
      "Esto activará el enlace de acceso inmediatamente (antes de la hora normal de check-in).",
    earlyAccessPinMsg: "Esto activará el PIN inmediatamente (antes de la hora normal de check-in).",
    earlyAccessHeader: "Acceso temprano",
    activate: "Activar",
    earlyAccessActivated: "Acceso temprano activado",
    okSummary: "OK",
    earlyAccessActivatedDetail: "Se activó el acceso temprano",
    couldNotActivateEarlyAccess: "No se pudo activar el acceso temprano",
    cancelReservationMsg:
      "Se cancelará la reserva por completo. Si ocupa varias habitaciones (incluso de distintos tipos), se cancelarán y liberarán todas. Esta acción no se puede deshacer.",
    goBack: "Volver",
    resolveOverbookingMsg:
      "Se verificará que ya no exista conflicto con otra reserva. Si está libre, la reserva pasará a confirmada y se mantendrán sus fechas bloqueadas en las OTAs.",
    confirmOverbookingHeader: "Confirmar reserva en overbooking",
    reservationConfirmed: "Reserva confirmada.",
    couldNotConfirmReservation: "No se pudo confirmar la reserva.",
    reservationCancelledFreed: "Reserva cancelada. Se liberaron {count} habitaciones.",
    otaLangPrompt:
      "Esta reserva OTA no tiene teléfono. Indica el idioma del mensaje para enviar el check-in por el chat de la OTA: es, en, fr, pt, ar, it, de",
    inviteProcessedEmailOta: "Invitacion procesada. Tambien se envio por correo y chat OTA.",
    inviteProcessedOta: "Invitacion procesada. Tambien se envio por chat OTA.",
    inviteProcessedEmail: "Invitacion procesada. Tambien se envio por correo.",
    couldNotSendCheckinInvite: "No se pudo enviar la invitacion de check-in",
    couldNotLoadConversations: "No se pudieron cargar las conversaciones",
    reservationUpdatedShort: "Reserva actualizada",
    couldNotUpdateReservation: "No se pudo actualizar la reserva",
    codeEmpty: "El código no puede estar vacío",
    attentionTitle: "Atención",
    accessCodeProcessed: "Código de acceso procesado correctamente",
    sentCheckTitle: "Enviado ✓",
    accessCodeSendProcessed: "Se procesó el envío del código de acceso.",
    couldNotSendCode: "No se pudo enviar el código",
    chatOta: "chat OTA",
    emailChannel: "correo",
    channelsUsed: "Canales utilizados: {channels}.",
  },

  // ── HotelReservationModal.vue ─────────────────────────────────────────────
  telefonoDelHuesped: {
    noValido: "El teléfono no parece válido para {pais}. Si el huésped es de otro país, cambia la bandera. Pulsa guardar otra vez para guardarlo igualmente.",
  },
  hotelResModal: {
    otaBanner:
      "Reserva OTA: no puedes modificar <strong>fechas</strong>, <strong>tipo</strong> ni <strong>cantidad de habitaciones</strong> desde WA Checkin. Debes hacerlo desde la OTA (Booking, Airbnb, etc.).",
    otaLock: "Reserva OTA: las fechas, tipo y cantidad solo pueden modificarse desde la OTA.",
    close: "Cerrar",
    placeholderEmail: "email@ejemplo.com",
    roomAbbr: "Hab.",
    fromCalendar: "desde el calendario",
    noMatches: "Sin coincidencias",
    undo: "Deshacer",
    removeRoom: "Quitar habitación",
    willBeRemovedOnSave: "Se quitará al guardar los cambios.",
    checkingAvailability: "Comprobando disponibilidad…",
    availableCount: "{count} disponible | {count} disponibles",
    notEnoughAvail: "Sin disponibilidad suficiente",
    freeCount: "{count} libre | {count} libres",
    total: "total",
    nightsCount: "{count} noche | {count} noches",
    resendConfirmationTitle: "Reenviar mensaje de confirmación",
    resendConfirmationSub: "Vuelve a enviar la plantilla de confirmación al huésped.",
    resendConfirmationNote:
      "Al modificar la reserva se <strong>reenviará la plantilla de confirmación</strong> de esta reserva.",
    room: "Habitación",

    // Toasts (script)
    noEnoughUnitsFree: "No hay disponibilidad suficiente. Unidades libres: {units}.",
    closedPeriodManual: "Las fechas incluyen días cerrados por el propietario.",
    noAvailForDates: "No hay disponibilidad para esas fechas.",
    selectRoomType: "Selecciona un tipo de habitación.",
    selectValidDates: "Selecciona fechas válidas.",
    enterGuestName: "Indica el nombre del huésped.",
    invalidEmail: "El email no es válido.",
    enterValidPhone: "Indica un teléfono válido.",
    noAvailCreateModify: "No hay disponibilidad para crear/modificar con esas fechas.",
    aRoom: "una habitación",
    notEnoughAvailIn: "Sin disponibilidad suficiente en: {names}.",
    missingOnCreate: "Falta onCreateReservation en el componente padre.",
    aRoomType: "un tipo de habitación",
    notEnoughAvailInType: `No hay disponibilidad suficiente en "{name}".`,
    sameHotelOnly: "Una reserva no puede mezclar habitaciones de dos hoteles. Quita las que no sean de este hotel.",
    otherHotelLinesDropped: "Se quitaron las habitaciones del hotel anterior: una reserva es de un solo hotel.",
    partiallyCreated: "Se crearon {ok} de {total} habitaciones y la siguiente falló. Revisa la reserva antes de volver a intentarlo.",
    reservationIdNotFound: "No se encontró ID de la reserva.",
    cannotRemoveAll: "No puedes quitar todas las habitaciones. Para eso cancela la reserva completa.",
    thisRoom: "esta habitación",
    confirmRemoval:
      "Vas a QUITAR de la reserva: {names}. Esas habitaciones se liberan y dejan de facturarse. ¿Continuar y guardar?",
    couldNotAdd: "No se pudo añadir {name}.",
    couldNotUpdate: `No se pudo actualizar "{name}".`,
    couldNotRemove: `No se pudo quitar "{name}".`,
    couldNotRemovePrimary: "No se pudo quitar la habitación principal.",
    reservationUpdated: "Reserva actualizada exitosamente",
    updatedPartially: "Se guardó solo una parte: revisa las habitaciones de la reserva.",
    couldNotUpdateReservation: "No se pudo actualizar la reserva.",
  },
};
